"use client";

import { useEffect, useState } from "react";

/**
 * Retarde la propagation d'une valeur qui change à la frappe.
 *
 * Vivait dans `library-modal.tsx`, qui en était l'unique consommateur. La
 * bibliothèque en compte deux maintenant (la recherche de l'accueil et celle
 * de la vue liste) et l'un des deux pilote l'URL : dupliquer le hook, ce
 * serait accepter que les deux champs n'attendent pas le même délai.
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);

    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
